import loadable from '@loadable/component';
import React from 'react';

import {
  Robots as MetaRobots,
  Title as MetaTitle,
} from 'src/shared/components/Meta';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

const NotFound = loadable(() => import('../NotFound'), {
  resolveComponent: module => module.NotFound,
});

const Router = () => {
  const t = useTranslate(TranslationNamespace.NOT_FOUND);

  return (
    <>
      <MetaRobots mode="none" />
      <MetaTitle title={t('pageNotFound')} />
      <NotFound />
    </>
  );
};

export { Router };
